<template>
  <ul>
    <li
      v-for="(item, idx) in currentLngTree"
      :key="idx"
      class="cursor-pointer sidebar-rounded"
      :class="{ 'mb-1': idx + 1 !== currentLngTree.length }"
    >
      <sidebar-body-header
        v-bind="item"
        @click="toggleLayer(item, item.id !== currentLayerId)"
        :expanded="item.id === currentLayerId"
      />
      <sidebar-list
        v-if="!!item.children?.length && item.id === currentLayerId"
        :items="item.children"
        :offersLayerId="item.id"
        :area-unit="offersAreaUnit"
      />
    </li>
  </ul>
</template>

<script>
import { get } from 'vuex-pathify';
import SidebarBodyHeader from '@/components/sidebar/SidebarBodyHeader';
import SidebarList from '@/components/sidebar/SidebarList';

export default {
  name: 'SidebarLists',
  components: { SidebarBodyHeader, SidebarList },
  computed: {
    dataSources: get('featuresData/dataSources'),
    offersDataSourceName: get('admin/settings@OFFERT_SETTING.value.datasource'),
    offersAreaAttributeName: get('admin/settings@OFFERT_SETTING.value.area_attribute'),
    offersAreaAttribute() {
      return this.dataSources[this.offersDataSourceName]?.attributes?.find(
        attribute => attribute.name === this.offersAreaAttributeName
      );
    },
    offersAreaUnit() {
      return this.offersAreaAttribute?.measurement_unit?.symbol || '';
    },

    offersTree: get('featuresData/offersTree'),
    currentLng() {
      return this.$i18n.locale;
    },
    currentLngTree() {
      return this.offersTree[this.currentLng];
    },
    currentLayerId() {
      return +this.$route.params.lid;
    },
  },
  methods: {
    toggleLayer(item, value) {
      if (value) this.$router.push({ name: 'main', params: { lid: item.id } });
      else this.$router.push({ name: 'main' });
    },
  },
};
</script>
